<app-language-flag-select
  [languages]="languages"
  [selectedValue]="selectedLanguageCode!"
  (selectedValueChange)="onLanguageModelChange($event)"
></app-language-flag-select>
